
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'ysh-flow-content',
    templateUrl: './ysh-flow-content.component.html',
    styleUrl: './ysh-flow-content.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatIconModule, MatTooltipModule]
})
export class YshFlowContentComponent {

}
